module.exports = __webpack_public_path__ + "static/media/verfied-green.91dccaad.svg";